import { render, staticRenderFns } from "./NotificationSection.vue?vue&type=template&id=29de5f7a&"
import script from "./NotificationSection.vue?vue&type=script&lang=js&"
export * from "./NotificationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports